/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Growl } from 'primereact/growl'

import { contentActions } from '../_actions'
import { messageConstants } from '../_constants'
import ManageContentComponent from '../components/ManageContentComponent'

function ManageContentContainer({ content, message, isContentLoading, getContent, updateContent }) {
  const growl = useRef()
  useEffect(() => {
    if (message) {
      growl.current.show({ severity: messageConstants.sevirity.success, summary: '', detail: message, life: 500 })
      getContent()
    }
  }, [message, getContent])
  return (<>
    <Growl ref={growl} />
    {isContentLoading && <div className="overlay">
      <div className="lds-ripple"><div></div><div></div></div>
    </div>}
    <div className="p-grid pageWrapper">
      <ManageContentComponent
        content={content}
        updateContent={updateContent}
        getContent={getContent}
      />
    </div>
  </>
  )
}
const mapStateToProps = state => {
  return {
    content: state.content?.data,
    message: state.content?.message,
    isContentLoading: state.content?.isLoading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getContent: () => dispatch(contentActions.getContent()),
    updateContent: (content) => dispatch(contentActions.updateContent(content)),
  }
}

ManageContentContainer.propTypes = {
  getContent: PropTypes.func,
  updateContent: PropTypes.func,
  content: PropTypes.object,
  message: PropTypes.string,
  isContentLoading: PropTypes.bool
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageContentContainer)
